// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger {
  display: inline-block;
  height: 22px;
  outline: none;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger:hover {
  opacity: 0.7;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger.app-components-Icons-BurgerButton-___BurgerButton-module__is-active:hover {
  opacity: 0.7;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner,
.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before,
.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  background-color: var(--colors-black);
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-box {
  width: 25px;
  height: 22px;
  display: inline-block;
  position: relative;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner,
.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before,
.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  width: 25px;
  height: 3px;
  background-color: var(--colors-black);
  border-radius: 4px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before,
.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  content: '';
  display: block;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before {
  top: -6px;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  bottom: -6px;
}

/*
 * Arrow
 */

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--arrow.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before {
  transform: translate3d(-8px, 0, 0) rotate(-45deg) scale(0.7, 1);
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--arrow.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  transform: translate3d(-8px, 0, 0) rotate(45deg) scale(0.7, 1);
}

/*
 * Slider
 */

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner {
  top: 6px;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before {
  top: 6px;
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 0.15s;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  top: 12px;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner {
  transform: translate3d(0, 6px, 0) rotate(45deg);
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::before {
  transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
  opacity: 0;
}

.app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider.app-components-Icons-BurgerButton-___BurgerButton-module__is-active .app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner::after {
  transform: translate3d(0, -12px, 0) rotate(-90deg);
}
`, "",{"version":3,"sources":["webpack://./app/components/Icons/BurgerButton/BurgerButton.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;;AAEF;EACE,+DAA+D;AACjE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;;EAEE;;AAEF;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,uCAAuC;EACvC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0DAA0D;EAC1D,UAAU;AACZ;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":[".hamburger {\n  display: inline-block;\n  height: 22px;\n  outline: none;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n}\n\n.hamburger:hover {\n  opacity: 0.7;\n}\n\n.hamburger.is-active:hover {\n  opacity: 0.7;\n}\n\n.hamburger.is-active .hamburger-inner,\n.hamburger.is-active .hamburger-inner::before,\n.hamburger.is-active .hamburger-inner::after {\n  background-color: var(--colors-black);\n}\n\n.hamburger-box {\n  width: 25px;\n  height: 22px;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: -2px;\n}\n\n.hamburger-inner,\n.hamburger-inner::before,\n.hamburger-inner::after {\n  width: 25px;\n  height: 3px;\n  background-color: var(--colors-black);\n  border-radius: 4px;\n  position: absolute;\n  transition-property: transform;\n  transition-duration: 0.15s;\n  transition-timing-function: ease;\n}\n\n.hamburger-inner::before,\n.hamburger-inner::after {\n  content: '';\n  display: block;\n}\n\n.hamburger-inner::before {\n  top: -6px;\n}\n\n.hamburger-inner::after {\n  bottom: -6px;\n}\n\n/*\n * Arrow\n */\n\n.hamburger--arrow.is-active .hamburger-inner::before {\n  transform: translate3d(-8px, 0, 0) rotate(-45deg) scale(0.7, 1);\n}\n\n.hamburger--arrow.is-active .hamburger-inner::after {\n  transform: translate3d(-8px, 0, 0) rotate(45deg) scale(0.7, 1);\n}\n\n/*\n * Slider\n */\n\n.hamburger--slider .hamburger-inner {\n  top: 6px;\n}\n\n.hamburger--slider .hamburger-inner::before {\n  top: 6px;\n  transition-property: transform, opacity;\n  transition-timing-function: ease;\n  transition-duration: 0.15s;\n}\n\n.hamburger--slider .hamburger-inner::after {\n  top: 12px;\n}\n\n.hamburger--slider.is-active .hamburger-inner {\n  transform: translate3d(0, 6px, 0) rotate(45deg);\n}\n\n.hamburger--slider.is-active .hamburger-inner::before {\n  transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);\n  opacity: 0;\n}\n\n.hamburger--slider.is-active .hamburger-inner::after {\n  transform: translate3d(0, -12px, 0) rotate(-90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hamburger": `app-components-Icons-BurgerButton-___BurgerButton-module__hamburger`,
	"is-active": `app-components-Icons-BurgerButton-___BurgerButton-module__is-active`,
	"hamburger-inner": `app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-inner`,
	"hamburger-box": `app-components-Icons-BurgerButton-___BurgerButton-module__hamburger-box`,
	"hamburger--arrow": `app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--arrow`,
	"hamburger--slider": `app-components-Icons-BurgerButton-___BurgerButton-module__hamburger--slider`
};
export default ___CSS_LOADER_EXPORT___;
